export default __webpack_public_path__ + "static/media/soldierOfOrban.3d1bb37f.jpg";